async function processDownloadResp(fetchResp: Response, name: string): Promise<File> {
    const data = await fetchResp.blob();
    return new File([data], name, { type: data.type });
}

function assertDownloadOk(fetchResp: Response) {
    if (!fetchResp.ok) {
        throw new Error(`Google Drive download failed (${fetchResp.status}): ${fetchResp.statusText}`);
    }
}

export async function downloadFileFromGDrive({ id, name, accessToken, mimeType }): Promise<File> {
    let url = `https://www.googleapis.com/drive/v3/files/${id}`;
    let fileName = name;
    if (mimeType?.includes("document")) {
        url += "/export?mimeType=text/plain";
    } else if (mimeType?.includes("spreadsheet")) {
        url += "/export?mimeType=application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileName = `${name}.xlsx`;
    } else {
        url += "?alt=media";
    }

    const fetchResp = await fetch(url, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
    assertDownloadOk(fetchResp);

    if (mimeType?.includes("document")) {
        return new File([await fetchResp.text()], `${name}.txt`, { type: "text/plain" });
    }

    return processDownloadResp(fetchResp, fileName);
}

export async function downloadFileFromBox({ id, name, accessToken }): Promise<File> {
    const fetchResp = await fetch(`https://api.box.com/2.0/files/${id}/content`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
    return processDownloadResp(fetchResp, name);
}

export async function downloadFileFromDropbox({ url, name }): Promise<File> {
    const fetchResp = await fetch(url);
    return processDownloadResp(fetchResp, name);
}

export async function downloadFileFromBynder({ url, name }): Promise<File> {
    const fetchResp = await fetch(url);
    return processDownloadResp(fetchResp, name);
}

export async function downloadFileFromOneDrive({ url, name }): Promise<File> {
    const fetchResp = await fetch(url);
    return processDownloadResp(fetchResp, name);
}

export async function downloadFileFromFrontify({ url, name }): Promise<File> {
    const fetchResp = await fetch(url);
    return processDownloadResp(fetchResp, name);
}
